module.exports = __webpack_public_path__ + "static/media/mask13.c8d55841.JPG";